import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { hasActiveSession } from "../services/auth";

const ProtectedRoute: React.FC<React.PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  const authenticated = hasActiveSession();

  return authenticated
    ? <>{children}</>
    : <Navigate to="/login" replace state={{ from: location.pathname }} />;
};

export default ProtectedRoute;
